var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28571 9.28125C2.28571 8.5043 2.92536 7.875 3.71429 7.875H6.57143C7.36071 7.875 8 8.5043 8 9.28125V12.0938C8 12.8707 7.36071 13.5 6.57143 13.5H3.71429C2.92536 13.5 2.28571 12.8707 2.28571 12.0938V9.28125ZM3.42857 9.28125V12.0938C3.42857 12.2484 3.55643 12.375 3.71429 12.375H6.57143C6.72857 12.375 6.85714 12.2484 6.85714 12.0938V9.28125C6.85714 9.12656 6.72857 9 6.57143 9H3.71429C3.55643 9 3.42857 9.12656 3.42857 9.28125ZM4.57143 2.25H11.4286V0.5625C11.4286 0.251859 11.6857 0 12 0C12.3143 0 12.5714 0.251859 12.5714 0.5625V2.25H13.7143C14.975 2.25 16 3.25723 16 4.5V15.75C16 16.991 14.975 18 13.7143 18H2.28571C1.02321 18 0 16.991 0 15.75V4.5C0 3.25723 1.02321 2.25 2.28571 2.25H3.42857V0.5625C3.42857 0.251859 3.68571 0 4 0C4.31429 0 4.57143 0.251859 4.57143 0.5625V2.25ZM1.14286 15.75C1.14286 16.3723 1.65464 16.875 2.28571 16.875H13.7143C14.3464 16.875 14.8571 16.3723 14.8571 15.75V6.75H1.14286V15.75ZM1.14286 4.5V5.625H14.8571V4.5C14.8571 3.87773 14.3464 3.375 13.7143 3.375H2.28571C1.65464 3.375 1.14286 3.87773 1.14286 4.5Z",
    fill: "#55585C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.20ab845658dad8432ed93cbb4f1e8564.svg";
export { ForwardRef as ReactComponent };